<span class="nav-header__text">{{title | translate}}</span>